import React, { useState } from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function SearchRender({ node }) {
  const content = node.content || {};
  
  const placeholder = content.placeholder || 'Suchen... z.B. O2 Mobile M';
  const buttonText = content.buttonText || 'Suchen';
  const actionUrl = content.actionUrl || '/search'; // wohin geht das Formular
  const layout = content.layout || 'inline'; // inline, block
  const borderRadius = content.borderRadius || '8px';
  const color = content.color || 'var(--tef-primary, #00A9E0)';

  return (
    <div style={{ width: '100%' }}>
      <form 
        action={actionUrl}
        method="GET"
        style={{
          display: 'flex',
          flexDirection: layout === 'inline' ? 'row' : 'column',
          gap: '8px',
          width: '100%'
        }}
        onSubmit={(e) => {
          // Im Designer unterbinden wir echte Submit-Events
          if (document.querySelector('.tef-canvas-area')) {
            e.preventDefault();
          }
        }}
      >
        <div style={{ 
          flexGrow: 1, 
          position: 'relative',
          display: 'flex',
          alignItems: 'center'
        }}>
          {/* Lupe Icon */}
          <span style={{ position: 'absolute', left: '16px', color: '#64748b' }}>🔍</span>
          <input 
            type="text" 
            name="q"
            placeholder={placeholder}
            style={{
              width: '100%',
              padding: '16px 16px 16px 48px',
              backgroundColor: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: borderRadius,
              color: '#f8fafc',
              fontSize: '16px',
              outline: 'none',
              transition: 'border-color 0.2s, background-color 0.2s',
            }}
            onFocus={(e) => {
              e.target.style.borderColor = color;
              e.target.style.backgroundColor = 'rgba(255,255,255,0.08)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = 'rgba(255,255,255,0.1)';
              e.target.style.backgroundColor = 'rgba(255,255,255,0.05)';
            }}
          />
        </div>
        
        <button 
          type="submit"
          style={{
            padding: '16px 32px',
            backgroundColor: color,
            color: '#fff',
            border: 'none',
            borderRadius: borderRadius,
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'opacity 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.opacity = '0.9'}
          onMouseLeave={(e) => e.target.style.opacity = '1'}
        >
          {buttonText}
        </button>
      </form>
    </div>
  );
}

registry.register('Search', {
  label: 'Erweiterte Suche',
  icon: '🔍', 
  category: 'layout', // oder form
  component: SearchRender,
  
  defaultProps: {
    content: {
      placeholder: 'Geben Sie einen Suchbegriff ein...',
      buttonText: 'Suchen',
      actionUrl: '/search',
      layout: 'inline',
      borderRadius: '8px',
      color: '#00A9E0'
    },
    style: {
      desktop: {
        marginBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Funktion & Texte',
          fields: [
            { name: 'content.placeholder', label: 'Lupe-Text (Platzhalter)', type: 'text' },
            { name: 'content.buttonText', label: 'Button-Label', type: 'text' },
            { name: 'content.actionUrl', label: 'Such-URL (Weiterleitung)', type: 'text' }
          ]
        },
        {
          title: 'Design',
          fields: [
            { name: 'content.layout', label: 'Layout Form', type: 'select', options: ['inline', 'block'] },
            { name: 'content.color', label: 'Hauptfarbe (Fokus & Button)', type: 'color' },
            { name: 'content.borderRadius', label: 'Eckenradius', type: 'text' }
          ]
        }
      ]
    }
  ]
});
